const termsOfService = {
  title: "Terms of Service",
  // NOTE: DE reference repo uses English copy here.
  sections: [
    {
      heading: "1. Agreement to Terms",
      paragraphs: [
        'By accessing and using the services of Elite Dental Solutions ("we," "our," or "us"), you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.',
      ],
    },
    {
      heading: "2. Description of Services",
      paragraphs: [
        "We provide dental and oral healthcare services, including but not limited to:",
      ],
      bullets: [
        "Dental examinations and consultations",
        "Preventive dental care",
        "Restorative treatments",
        "Cosmetic dental procedures",
        "Oral surgery",
        "Emergency dental care",
      ],
    },
    {
      heading: "3. Appointments and Cancellations",
      paragraphs: [
        "We require 24 hours notice for appointment cancellations. Late cancellations or missed appointments may incur a fee. We reserve the right to request a deposit for certain procedures or treatments.",
      ],
    },
    {
      heading: "4. Payment Terms",
      paragraphs: [
        "Payment is required at the time of service unless other arrangements have been made. We accept various payment methods including cash, credit cards, and approved payment plans. Insurance claims are the responsibility of the patient.",
      ],
    },
    {
      heading: "5. Medical Information",
      paragraphs: [
        "You agree to provide accurate and complete medical history information. Failure to disclose relevant medical information may affect your treatment outcomes and could be dangerous to your health.",
      ],
    },
    {
      heading: "6. Treatment Decisions",
      paragraphs: [
        "While we provide professional recommendations, you have the right to make informed decisions about your treatment. We will explain treatment options, risks, and benefits to help you make these decisions.",
      ],
    },
    {
      heading: "7. Website Use",
      paragraphs: [
        "Our website is for informational purposes only. While we strive to provide accurate information, it should not be considered medical advice. Always consult with a dental professional for specific medical advice.",
      ],
    },
    {
      heading: "8. Limitation of Liability",
      paragraphs: [
        "We strive to provide the highest quality dental care but cannot guarantee specific outcomes. We are not liable for any indirect, consequential, or incidental damages related to our services.",
      ],
    },
    {
      heading: "9. Changes to Terms",
      paragraphs: [
        "We reserve the right to modify these terms at any time. Changes will be effective immediately upon posting to our website. Continued use of our services constitutes acceptance of modified terms.",
        "Last updated:",
      ],
      lastUpdatedLocale: "de-DE",
    },
  ],
};

export default termsOfService;

